import React, { useContext, useEffect } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import useContentToggle from "./useContentToggle";

const ContentToggleTickerSettings = (props) => {
  const [contextData] = useContext(VariantContextData);

  const toggle_item = props.toggle_item;
  const element = contextData.objects.variant.elements[toggle_item.element_id];

  const { ContentToggle } = useContentToggle();

  useEffect(() => {
    ContentToggle.sortableStart(toggle_item);
  });

  const thumbnailUrl = toggle_item.content;

  return (
    <VariantBuilderSetting
      object={toggle_item}
      setting_name="[modal_trigger]"
      setting_type="item_v2"
      object_type="content_toggle_items"
      object_id={toggle_item.id}
      title={`Image ${toggle_item.position}`}
      condition={element.element_type == "ticker"}
      label_max_length={25}
      label_hover_max_length={14}
      style={{
        marginBottom: "0px",
      }}
      position={toggle_item.position ? toggle_item.position : ""}
      duplicate_payload={{
        element_id: element.id,
      }}
      label_prepend={
        <div
          className="flex items-center justify-center"
          style={{
            width: 32,
            height: 32,
            borderRadius: 4,
            overflow: "hidden",
            background: "#e5e7eb",
          }}
        >
          {thumbnailUrl ? (
            <img
              src={thumbnailUrl}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          ) : null}
        </div>
      }
    >
      <VariantBuilderSetting
        object={toggle_item}
        label="Image"
        setting_name="[content]"
        setting_type="image"
        object_type="content_toggle_items"
        object_id={toggle_item.id}
        value={toggle_item.content ? toggle_item.content : ""}
      />

      <VariantBuilderSetting
        object={toggle_item}
        label="Alt text"
        setting_name="[options][alt]"
        setting_type="text"
        object_type="content_toggle_items"
        object_id={toggle_item.id}
        value={
          toggle_item.options && toggle_item.options.alt
            ? toggle_item.options.alt
            : ""
        }
      />

      <VariantBuilderSetting
        object={toggle_item}
        label="Link URL"
        setting_name="[options][link]"
        setting_type="text"
        object_type="content_toggle_items"
        object_id={toggle_item.id}
        value={
          toggle_item.options && toggle_item.options.link
            ? toggle_item.options.link
            : ""
        }
      />
    </VariantBuilderSetting>
  );
};

export default ContentToggleTickerSettings;
